module.exports = __webpack_public_path__ + "static/media/Soham_Kumthekar.dc059d50.jpg";